import { gql, useMutation } from "@apollo/client";

export const REMOVE_PMX_ACTIVITY_FAVORITE_MUTATION = gql`
  mutation removePmxActivityFavorite($id: ID!) {
    removePmxActivityFavorite(input: { id: $id })
  }
`;

export function useRemovePmxActivityFavoriteMutation() {
  const [
    removePmxActivityFavorite,
    {
      loading: loadingRemoveFavoritesMutation,
      error: errorRemoveFavoritesMutation
    }
  ] = useMutation(REMOVE_PMX_ACTIVITY_FAVORITE_MUTATION);

  return {
    removePmxActivityFavorite,
    loadingRemoveFavoritesMutation,
    errorRemoveFavoritesMutation
  };
}
